import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPredefinedRoleName.ts
var t = () => e("predefinedRoleName");
//#endregion
export { t as useTrPredefinedRoleName };
